import React from "react";
import "./styles.css";

export default function TitlePage(props) {
  return (
    <div style={props.style}>
      <h1 className="title-page">{props.name}</h1>
      <h5 style={{color: '#555'}}>{props.desc}</h5>
    </div>
  );
}
